module.exports = "/hub/_next/static/assets/4dce26c7e0f591ac9c8f6234db12fd42.svg";